var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('h2',[_vm._v(_vm._s(_vm.$t("common.teamStats")))]),_c('XTable',{attrs:{"x-content":_vm.content,"x-columns":_vm.columns},scopedSlots:_vm._u([{key:"cell[League]",fn:function({row,cell}){return [_c('router-link',{attrs:{"to":`/team/${_vm.teamId}/${row.League_id}/${row.Season_id}`}},[_vm._v(_vm._s(cell))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }